import { stateAccountsSelector } from "./slice-data/stateAccountsSelector";
import { RootState } from "../../store";

export const accountsWithMissingPermissionsByIdsSelector = (
  state: RootState,
  accountIds: string[],
) => {
  const accounts = stateAccountsSelector(state)?.filter((account) =>
    accountIds.includes(account.id),
  );

  return accounts?.map((account) => ({
    id: account.id,
    name: account.provider_account_name || account.provider_account_id,
    url: `/${account.type}/${account.id}`,
    provider: account.type ?? "aws",
  }));
};
